import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function useAuthToken() {
  const { user, getIdToken } = useAuth();
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchToken = async () => {
      if (user) {
        const idToken = await getIdToken();
        setToken(idToken);
      } else {
        setToken(null);
      }
      setLoading(false);
    };

    fetchToken();
  }, [user, getIdToken]);

  return { token, loading };
}
